import React from 'react';

import type { TFunction } from './../../ricos-types';
import { GenericError } from './../../ui-components';

import { RENDERING_ERROR } from './data-hooks';

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode; t: TFunction },
  { hasError: boolean }
> {
  constructor(props: $TSFixMe) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    console.error(error);
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <GenericError text={this.props.t('Plugin_Rendering_Error')} dataHook={RENDERING_ERROR} />
      );
    }

    return this.props.children;
  }
}
